import { useState, useEffect, useCallback } from 'react';
import { DEFAULT_HOLD_TIMEOUT } from '@portals/ui-kit/lib/warning-cookies-banner/_constants';
import { WarningCookiesBannerCard } from '@portals/ui-kit/lib/warning-cookies-banner/_components/warning-cookies-banner-view';
import { cookieBannerClickEvent } from '@/_analytic/events/cookie-banner-click-event';
import { EStorageType, getCache, setCache } from '@/_utils';

type TProps = {
  cookieStoragePrefix: string;
  text: string;
  buttonAgreedText: string;
};

const COOKIE_BANNER_AGREED = true;

export const WarningCookiesBanner = ({
  cookieStoragePrefix,
  text,
  buttonAgreedText,
}: TProps) => {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const isCookieBannerAgreed = getCache<boolean>({
        key: cookieStoragePrefix,
        defaultValue: false,
        storageType: EStorageType.localStorage,
      });

      setIsShown(!isCookieBannerAgreed);
    }, DEFAULT_HOLD_TIMEOUT);

    return () => clearTimeout(timeoutId);
  }, [cookieStoragePrefix]);

  const clickAgreed = useCallback(() => {
    setCache<boolean>({
      key: cookieStoragePrefix,
      data: COOKIE_BANNER_AGREED,
      storageType: EStorageType.localStorage,
    });

    setIsShown(false);
    cookieBannerClickEvent();
  }, [cookieStoragePrefix]);

  if (!isShown) return null;

  return (
    <WarningCookiesBannerCard
      buttonAgreedtext={buttonAgreedText}
      clickAgreed={clickAgreed}
      isShown={isShown}
      text={text}
    />
  );
};
